import _inheritsLoose from "@babel/runtime/helpers/esm/inheritsLoose";
import _wrapNativeSuper from "@babel/runtime/helpers/esm/wrapNativeSuper";
export var SplitError = /*#__PURE__*/function (_Error) {
  _inheritsLoose(SplitError, _Error);

  function SplitError(msg) {
    var _this;

    if (msg === void 0) {
      msg = 'Split Error';
    }

    _this = _Error.call(this, msg) || this;
    _this.message = msg;
    return _this;
  }

  return SplitError;
}( /*#__PURE__*/_wrapNativeSuper(Error));
export var SplitTimeoutError = /*#__PURE__*/function (_SplitError) {
  _inheritsLoose(SplitTimeoutError, _SplitError);

  function SplitTimeoutError(msg) {
    return _SplitError.call(this, msg || 'Split Timeout Error') || this;
  }

  return SplitTimeoutError;
}(SplitError);
export var SplitNetworkError = /*#__PURE__*/function (_SplitError2) {
  _inheritsLoose(SplitNetworkError, _SplitError2);

  function SplitNetworkError(msg, code) {
    var _this2;

    _this2 = _SplitError2.call(this, msg || 'Split Network Error') || this;
    _this2.statusCode = code;
    return _this2;
  }

  return SplitNetworkError;
}(SplitError);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@splitsoftware/splitio/es/utils/lang/Errors.js
// module id = 280
// module chunks = 39